<div class="ui-input-button-group flex">
  <button
    class="lum-button ui-input-button-group__button"
    [disabled]="disabledButton"
    (click)="onButtonClick()"
  >
    {{ label }}
  </button>
  <input
    type="text"
    class="lum-input ui-input-button-group__input"
    [disabled]="disabledInput"
    [placeholder]="placeholder"
    [value]="value"
    (input)="onInputChange($event)"
  />
</div>
